/**
 * Created by vladislav on 7/14/2025
 */

const Cups = function () {};

Cups.prototype.join = function (cupName, country, user, callback) {
    ConnectorRestClient.post(
        `${connector.config.multiApiURL}/cup/join/${cupName}/${country}`,
        user,
        (data) => {
            callback(data);
        },
        () => {
            callback();
        }
    );
};

Cups.prototype.get = function (cupId, userId, callback) {
    userId = encodeURIComponent(userId);
    
    ConnectorRestClient.get(
        `${connector.config.multiApiURL}/cup/${cupId}/${userId}`, 
        {}, 
        (data) => {
            callback(true, data);
        },
        () => {
            callback(false);
        }
    );
};

Cups.prototype.getTop = function (cupName, userId, callback) {
    userId = encodeURIComponent(userId);

    ConnectorRestClient.get(`${connector.config.multiApiURL}/cup/leaders/${cupName}/${userId}`, {}, callback, () => {
        callback();
    });
};

Cups.prototype.postScore = function (cupId, userId, delta, callback) {
    ConnectorRestClient.post(`${connector.config.multiApiURL}/cup/${cupId}`, {
        userId,
        delta
    }, () => {
        callback(true);
    }, () => {
        callback(false);
    });
};

Cups.prototype.updateProfile = function (cupId, userId, data, callback = () => {}) {
    ConnectorRestClient.post(`${connector.config.multiApiURL}/cup/updateprofile/${cupId}`, {
        userId,
        name: data.name,
        avatar: data.avatar
    }, () => {
        callback(true);
    }, () => {
        callback(false);
    });
};

Cups.prototype.addFakePlayers = function (cupId, amount, callback) {
    ConnectorRestClient.get(`${connector.config.multiApiURL}/cup/addfakeplayers/${cupId}/${amount}`, {}, () => {
        callback(true);
    }, () => {
        callback(false);
    });
};